import createLoadRemoteModule, { createRequires } from '@paciolan/remote-module-loader';
import { resolve } from "./remote-component.config.js";
var requires = createRequires(resolve);
export var loadRemoteModule = createLoadRemoteModule({
  requires
});
export default loadRemoteModule;
//# sourceMappingURL=loadRemoteModule.js.map